// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"FaceChooser_wrapper__2csgA","facePane":"FaceChooser_facePane__3K7s8"};